"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polygon = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../../shapes/ShapeLoop");
/**
 * Polygon shape
 *
 * @category Shapes.ShapeLoop
 * @class Polygon
 * @extends {ShapeLoop}
 */
class Polygon extends ShapeLoop_1.ShapeLoop {
    /**
     * Is based on ShapeLoop and you can pass `sideNumber` property to define
     * a number of sides.
     *
     * @param settings
     */
    constructor(settings = {}) {
        settings.type = settings.type || 'Polygon';
        settings.loopDependencies = (settings.loopDependencies || []).concat(['sideNumber']);
        super(settings, true);
        this.props.sideNumber = settings.sideNumber;
        this.loop = {
            start: 0,
            end: math_1.PI2,
            inc: (propArguments) => {
                return math_1.PI2 / this.getProp('sideNumber', propArguments, 5);
            },
            vertex: shapeLoopRepetition => {
                return [Math.cos(shapeLoopRepetition.current), Math.sin(shapeLoopRepetition.current)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
}
exports.Polygon = Polygon;
//# sourceMappingURL=Polygon.js.map